/**
 * Global Accordion Handler (event-delegated)
 * Handles accordion toggle for all accordion variants (standard, process, cart, configurator).
 * Uses a single delegated listener on document so it works for accordions added at any time
 * (theme-rendered, AJAX-loaded, or pasted into page bodies) with no timing dependency.
 */

(function () {
  if (window.accordionInitialized) {
    return;
  }
  window.accordionInitialized = true;

  function handleAccordionClick(event) {
    // Find the toggle the click originated from (handles clicks on inner elements like the chevron)
    const toggle = event.target.closest('[data-accordion-toggle]');
    if (!toggle) return;

    const section = toggle.closest('.rr-accordion');
    if (!section) return;

    if (section.classList.contains('rr-accordion--configurator')) {
      // Configurator style: toggle "collapsed" class
      section.classList.toggle('collapsed');
    } else {
      // Standard, process, and cart styles: toggle "open" class
      section.classList.toggle('open');
    }
  }

  // Single delegated listener — catches every current and future accordion toggle.
  document.addEventListener('click', handleAccordionClick);

  // Kept for backward compatibility; delegation means no re-scan is actually needed,
  // but dispatching this event remains harmless.
  document.addEventListener('accordion:refresh', function () {});
})();